var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCalendarinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 24 26",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.333 2.5h-1.166V1.334A1.17 1.17 0 0019 .167a1.17 1.17 0 00-1.167 1.167V2.5H6.167V1.334A1.17 1.17 0 005 .167a1.17 1.17 0 00-1.167 1.167V2.5H2.667A2.34 2.34 0 00.333 4.834V23.5a2.34 2.34 0 002.334 2.334h18.666a2.34 2.34 0 002.334-2.334V4.834A2.34 2.34 0 0021.333 2.5zm-1.166 21H3.833a1.17 1.17 0 01-1.166-1.166v-14h18.666v14a1.17 1.17 0 01-1.166 1.166z",
    fill: "inherit"
  })));
}

export default SvgCalendarinline;